module.exports = __webpack_public_path__ + "img/IT0001825324407.3a519974.png";